import React, { useState } from 'react';
import CookieBanner from '@components/cookies/CookieBanner';
import ResidentList from '@components/resident-list';
import CarehomeActivities from '@components/carehome-activites/CarehomeActivities';
import { usePartner } from '@contexts/PartnerContext';
import ProfileDetails from '@components/homepage/profile-details/ProfileDetails';
import AdvanceCarePlanning from '@components/homepage/advance-care-planning';
import ProgressData from '@components/homepage/progress-data';
import './styles.scss';
import HomepageButtons from '@components/homepage/HomepageButtons';
import AcpUpdatedTable from '@components/homepage/AcpUpdatedTable';

const HomePage: React.FC = () => {
  const [totalResidents, setTotalResidents] = useState<number>(0);
  const [carePlaceName, setCarePlaceName] = useState('');
  const { selectedPartnerId } = usePartner();

  return (
    <div className="govuk-width-container">
      <CookieBanner />
      <ProfileDetails />
      <AdvanceCarePlanning
        title="Advance Care Planning"
        setTotalResidents={setTotalResidents}
        setCarePlaceName={setCarePlaceName}
      />
      <HomepageButtons />
      <AcpUpdatedTable partnerCarehomeId={selectedPartnerId || ''} />
      <ResidentList
        partnerCarehomeId={selectedPartnerId || ''}
        carePlaceName={carePlaceName}
      />
      <ProgressData
        partnerCarehomeId={selectedPartnerId || ''}
        totalResidents={totalResidents}
      />
      <div className="shadow mb-10 mt-10 govuk-bp:mt-14">
        <CarehomeActivities partnerCarehomeId={selectedPartnerId || ''} />
      </div>
    </div>
  );
};

export default HomePage;
